













































import { computed, defineComponent } from '@vue/composition-api';
import { Computed }                  from '@/types';
import { useGlobals }                from '@/hooks/use-globals';
import { useSidePanel }              from '@/views/users/hooks/use-side-panel';
import { useUser }                   from '@/views/users/hooks/use-user';
import cIconTrashCan                 from '@/components/icons/icon-trash-can.component.vue';
import cIconEdit                     from '@/components/icons/icon-edit.component.vue';
import cIconLock                     from '@/components/icons/icon-lock.component.vue';

export default defineComponent({
  name: 'cUsersTableBody',
  components: {
    cIconEdit,
    cIconTrashCan,
    cIconLock,
  },
  setup() {
    const { store } = useGlobals();
    const { showEditUserFormPanel, showEditPasswordFormPanel } = useSidePanel();
    const { users, removeUser } = useUser();
    const isDataLoading: Computed<boolean> = computed((): boolean => store.state.views.vUsers.isDataLoading);
    const columns: Computed<string[]> = computed((): string[] => store.state.views.vUsers.table.columns);

    return {
      isDataLoading,
      columns,
      users,
      showEditUserFormPanel,
      showEditPasswordFormPanel,
      removeUser,
    };
  },
});
